import { ComputeResource as ZH_CHS } from '../i18n/zh-CHS/ComputeResource';
import { ComputeResource as EN } from '../i18n/en/ComputeResource';
import { ComputeResource as ZH_CHT } from '../i18n/zh-CHT/ComputeResource';

export class ComputeLocalePipe {
  //语言编号
  private languageCode: string;
  //资源信息
  private resource: {};

  //构造资源
  constructor(localeId: string) {
    localeId = localStorage.getItem('languageCode') || 'zh-CHS';
    this.languageCode = localeId || "zh-CHS";

    //语言扩展时，此处需调整
    if (this.languageCode == 'en')
      this.resource = EN;
    else if (this.languageCode == "zh-CHT")
      this.resource = ZH_CHT;
    else
      this.resource = ZH_CHS;
  }

  //获取资源
  transform(name: string): any {
    return this.resource[name] || name;
  }

}
